define(["require", "exports", "knockout"], function (require, exports, ko) {
    "use strict";
    var CustomerCoordinatorModel = /** @class */ (function () {
        function CustomerCoordinatorModel(data) {
            this.Id = ko.observable(0);
            this.Coordinator = ko.observable();
            this.Extension = ko.observable();
            this.Phone = ko.observable();
            this.CustomerId = ko.observable();
            this.CustomerName = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, CustomerCoordinatorModel.Mapping, self);
            }
        }
        CustomerCoordinatorModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new CustomerCoordinatorModel(options.data);
            }
        };
        return CustomerCoordinatorModel;
    }());
    return CustomerCoordinatorModel;
});
//# sourceMappingURL=CustomerCoordinatorModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/CustomerCoordinatorModel.js
// module id = 271
// module chunks = 2